/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Ils } from '../../models/ils';

export interface IlsControllerFindIlssByLabId$Params {
  labId: string;
}

export function ilsControllerFindIlssByLabId(http: HttpClient, rootUrl: string, params: IlsControllerFindIlssByLabId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Ils>>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerFindIlssByLabId.PATH, 'get');
  if (params) {
    rb.path('labId', params.labId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Ils>>;
    })
  );
}

ilsControllerFindIlssByLabId.PATH = '/ils/lab/{labId}';
